import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rGrupSirketDegerlemeUstBilgi } from '../../../../api/models/rGrupSirketDegerlemeUstBilgi';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rGrupSirketDegerlemeUstBilgi>,
  rGrupSirketDegerlemeUstBilgi
>(
  ActionSubTypes.API_GRUPSIRKETDEGERLEMEUSTBILGI,
  DefaultInputDataStateModel<pList, rGrupSirketDegerlemeUstBilgi>()
);
